import React, { useLayoutEffect } from 'react';

const ErrorPage3DS = () => {
  /* istanbul ignore next */
  useLayoutEffect(() => {
    const styles = [
      ...document.querySelectorAll('style'),
      ...document.querySelectorAll('link'),
    ];
    styles.map((el) => el.remove());
  }, []);

  return (
    <div id="divMainId" className="divMain">
      <div style={{ marginLeft: '5px', marginTop: '10px' }}>
        <h2>Oops ! An error occurred!!!</h2>
        <h3>Internal processing Error..!!!</h3>
      </div>
    </div>
  );
};

export default ErrorPage3DS;
